import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavBarObject} from '../../../_components/nav-bar/config';
import {EstudioService} from '../../estudio/estudio.service';
import {AsistenciaService} from '../_services/asistencia.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {DynamicBarService} from '../../../_components/dynamic-bar/dynamic-bar.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'reporte-curso',
  standalone: false,
  templateUrl: 'reporte-alertas.component.html',
  styleUrls: [
    '../reporte-director-curso/reporte-director-curso.component.scss',
    '../../nivelaciones/citacion-materia-curso/citacion-materia-curso.component.scss'
  ]
})

export class AsistenciaReporteAlertasComponent implements OnInit, OnDestroy {
  periodosNavBar;
  periodoID: number;

  displayedColumns = ['Curso', 'Alumno', 'Materias', 'NotaPeriodo', 'NotaAcumulada', 'AyR', 'FaltaTarea'];
  dataSource: MatTableDataSource<any>;
  tiposAsistencia: any;

  viewMode = 'percentage';

  periodosSub: Subscription;
  acumuladoSub: Subscription;
  paramsSub: Subscription;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private estudioService: EstudioService,
              private asistenciaService: AsistenciaService,
              private dynamicBarService: DynamicBarService,
              private titleService: Title) {
  }

  ngOnInit() {
    this.tiposAsistencia = this.route.parent.snapshot.data['tiposAsistencia'];
    this.periodoID = +this.route.snapshot.paramMap.get('periodoID');
    this.periodosSub = this.estudioService.getPeriodos(true).subscribe(res => {
      const periodos = this.asistenciaService.extractData(res);
      const periodo = periodos[0];
      if (+this.periodoID === 0 || this.periodoID == null) {
        this.periodoID = periodo.id;
      }
      if (this.periodosNavBar) {
        this.periodosNavBar = undefined;
      }
      this.periodosNavBar = [];
      periodos.map(periodoI => {
        this.periodosNavBar.push(new NavBarObject(
          periodoI.nombre,
          [`/asistencia/reporte/alumnos/alertas/periodo/${periodoI.id}`],
          periodoI.id,
          [new NavBarObject('Acumulado', [`/asistencia/reporte/alumnos/alertas/periodo/${periodoI.id}`], periodoI.id)]
            .concat(periodoI.periodos.map((child, i) => {
                if (child.tipo < 2) {
                  return new NavBarObject(`Periodo ${child.nombre}`,
                    [`/asistencia/reporte/alumnos/alertas/periodo/${child.id}`], child.id);
                } else {
                  return false;
                }
              })
            )
        ));
      });
    });

    this.paramsSub = this.route.params.subscribe(params => {
      this.periodoID = +params['periodoID'] || 0;
      this.dataSource = null;

      this.acumuladoSub = this.asistenciaService.getReporteAcumuladoAlertas(this.periodoID).subscribe(res => {
        this.dataSource = new MatTableDataSource<any>(this.asistenciaService.extractData(res));
      });
    });


    this.dynamicBarService.setBarra('asistencia-alertas-barra');
    this.titleService.setTitle('Asistencia - Alumnos con alerta');
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnDestroy() {
    if (this.periodosSub) {
      this.periodosSub.unsubscribe();
    }
    if (this.acumuladoSub) {
      this.acumuladoSub.unsubscribe();
    }
  }

  filtroTexto(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }

  changeViewMode(viewMode) {
    this.viewMode = viewMode;
    this.router.navigate(['.'], {relativeTo: this.route, queryParams: {viewMode}, replaceUrl: true});
  }

  getDetails(fila, materiaID) {
    if (fila.hasOwnProperty('detalle') && fila.detalle.show) {
      fila.detalle = {show: false};
    } else {
      fila.detalle = {show: false};
      this.asistenciaService.getDetailAcumulada(fila.alumnoId, materiaID, this.periodoID).subscribe(res => {
        fila.detalle['listaDetalles'] = this.asistenciaService.extractData(res);
        fila.detalle.show = true;
      });
    }
  }
}
